import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { ImportedEmployee } from 'modules/employees/lib/ImportedEmployee'

interface Props {
  selectedEmployees: ImportedEmployee[]
  onClickImport: () => void
}

const ImportButton = ({ selectedEmployees, onClickImport }: Props) => {
  const count = selectedEmployees.length
  const disabledLabel = i18n.t('import.import_valid.zero')

  const enabledLabel = i18n.tp('import.import_valid', {
    count,
  })

  return (
    <Button disabled={!count} onClick={onClickImport}>
      {!count ? disabledLabel : enabledLabel}
    </Button>
  )
}

export default observer(ImportButton)
